export class OnboardingContactForm {
  public internalAdminName: string = "";
  public internalAdminEmail: string = "";
  public internalAdminNumber: string = "";
  // public countryCode: string = "+ 43";
  public techQuestionsEmail: string = "";
  public organisationQuestionEmail: string = "";
}
